import * as IconMui from "@mui/icons-material";
import { StyledIcon } from "./style";

export type CursorValue =
  | "auto"
  | "pointer"
  | "default"
  | "text"
  | "wait"
  | "help"
  | "move"
  | "not-allowed"
  | "crosshair"
  | "e-resize"
  | "n-resize"
  | "s-resize"
  | "w-resize"
  | "ne-resize"
  | "nw-resize"
  | "se-resize"
  | "sw-resize"
  | "progress"
  | "alias"
  | "zoom-in"
  | "zoom-out"
  | "none";

export type TIcon = keyof typeof IconMui;

interface ModalIconProps {
  icon: keyof typeof IconMui;
  onClick?: (event: any) => void;
  circular?: boolean;
  iconColor?: string;
  circularColor?: string;
  circularBorder?: boolean;
  size?: number;
  cursor?: CursorValue;
  padding?: string;
}

export function ModalIcon({
  icon,
  circular,
  iconColor,
  onClick,
  circularColor,
  circularBorder,
  size = 24,
  cursor = "auto",
  padding = "auto",
}: ModalIconProps) {
  const Icon = IconMui[icon];

  const handleClick = (event: any) => {
    if (onClick) {
      onClick(event); // Chama a função onClick passada como prop
    }
  };

  function render(): JSX.Element {
    if (circular) {
      return (
        <StyledIcon
          circularColor={circularColor}
          iconColor={iconColor}
          circularBorder={circularBorder}
          cursor={cursor}
          padding={padding}
        >
          <Icon
            component="svg"
            onClick={handleClick}
            color="primary"
            sx={{
              color: iconColor || undefined,
              margin: 1,
              fontSize: size,
            }}
          />
        </StyledIcon>
      );
    }
    return (
      <Icon
        component="svg"
        style={{ cursor: cursor, color: iconColor ?? "white" }}
        onClick={handleClick}
      />
    );
  }

  return render();
}
